import type { MessageKey } from "./ru"

export const siMessages = {
  "common.loading": "පූරණය වෙමින්...",
  "common.error": "දෝෂය",
  "common.back": "ආපසු",
  "common.next": "ඊළඟ",
  "common.search": "සොයන්න",
  "auth.loginErrorTitle": "පිවිසුම් දෝෂය",
  "auth.openViaTelegram": "Telegram හරහා යෙදුම විවෘත කරන්න",
  "auth.telegramRequired": "යෙදුම Telegram හරහා විවෘත කළ යුතුය",
  "auth.authorizationError": "අවසර දීමේ දෝෂය",
  "device.rotatePortrait": "උපාංගය සිරස් අතට හරවන්න",
  "country.brazil": "බ්‍රසීලය",
  "country.vietnam": "වියට්නාමය",
  "country.egypt": "ඊජිප්තුව",
  "country.india": "ඉන්දියාව",
  "country.indonesia": "ඉන්දුනීසියාව",
  "country.iran": "ඉරානය",
  "country.spain": "ස්පාඤ්ඤය",
  "country.italy": "ඉතාලිය",
  "country.kazakhstan": "කසකස්තානය",
  "country.colombia": "කොලොම්බියාව",
  "country.malaysia": "මැලේසියාව",
  "country.mexico": "මෙක්සිකෝව",
  "country.nigeria": "නයිජීරියාව",
  "country.pakistan": "පාකිස්තානය",
  "country.russia": "රුසියාව",
  "country.usa": "ඇමරිකා එක්සත් ජනපදය",
  "country.turkey": "තුර්කිය",
  "country.uzbekistan": "උස්බෙකිස්තානය",
  "country.ukraine": "යුක්රේනය",
  "country.philippines": "පිලිපීනය",
  "countrySelection.chooseCountry": "රට තෝරන්න",
  "countrySelection.openAria": "රට තෝරන්න",
  "languageSelection.chooseLanguage": "භාෂාව තෝරන්න",
  "commercial.direction.autotrade": "වාහන වෙළඳපොළ",
  "commercial.direction.insurance": "රක්ෂණය",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "මාර්ග සහාය",
  "commercial.searchLabel": "BeepApp සෙවීම",
  "commercial.cityPlaceholder": "නගරය ඇතුළත් කරන්න",
  "commercial.emptyTitle": "අද දීමනා නැත",
  "commercial.emptyLine1": "ඔබේ නගරයේ තවම සක්‍රීය BeepApp හවුල්කරුවන් නැත",
  "commercial.emptyLine2": "ඔවුන් සොයා සම්බන්ධ කිරීමට අපි දැනටමත් කටයුතු කරමින් සිටිමු",
  "commercial.emptyLine3": "නව දීමනා මෙහි ස්වයංක්‍රීයව පෙනෙනු ඇත",
  "commercial.helperLine1": "ලබාගත හැකි දීමනා බැලීමට",
  "commercial.helperLine2": "ඔබේ නගරය ඇතුළත් කරන්න",
  "commercial.partnerPrompt": "BeepApp හවුල්කරුවෙකු වීමට කැමතිද?",
  "commercial.apply": "අයදුම් කරන්න",
  "main.admin": "පරිපාලක",
  "main.garage": "Garage",
  "main.signalSent": "සංඥාව යවන ලදී",
  "main.partnerInviteUnavailable": "හවුල්කරු ආරාධනය ලබාගත නොහැක",
  "main.enterPlate": "වාහන අංකය ඇතුළත් කරන්න",
  "main.searchError": "සෙවීමේ දෝෂය",
  "main.signalSendError": "සංඥාව යැවීමට නොහැකි විය",
  "main.shareCardPrefix": "අංක පත්‍රිකාව",
  "main.shareLinkError": "සබැඳිය සකස් කළ නොහැකි විය",
  "main.searchByPlateAria": "වාහන අංකයෙන් සොයන්න",
  "main.russianPlateAria": "රුසියානු වාහන අංකය",
  "main.plateAria": "වාහන අංකය",
  "main.findPlateAria": "අංකය සොයන්න",
  "main.loadingVehicle": "අංක පත්‍රිකාව පූරණය වෙමින්…",
  "main.leaveSignal": "සංඥාවක් යවන්න",
  "main.share": "බෙදාගන්න",
  "signalSelection.chooseType": "සංඥා වර්ගය තෝරන්න",
  "signalSelection.category.attention": "පුද්ගලික",
  "signalSelection.category.road": "මාර්ග",
  "signalSelection.category.urgent": "හදිසි",
  "signalSelection.chooseSignal": "සංඥාව තෝරන්න",
  "signalSelection.suggestOwn": "ඔබේ යෝජනාව දෙන්න",
  "signalConfirmation.title": "සංඥාව තහවුරු කරන්න",
  "signalConfirmation.plateHeading": "වාහන අංකය පරීක්ෂා කරන්න",
  "signalConfirmation.signalHeading": "තෝරාගත් සංඥාව පරීක්ෂා කරන්න",
  "signalConfirmation.replyTitle": "Telegram හරහා පිළිතුරු දීමට ඉඩ දෙන්න",
  "signalConfirmation.replyBody": "මෙය සක්‍රීය කළොත් අංකයේ හිමිකරුට\nTelegram හරහා ඔබට ලිවිය හැක. පිළිතුරු ලබාදිය හැක්කේ\nඔබට @username එකක් තිබේ නම් පමණි. පිළිතුරු දීමේ තීරණය\nඅංකයේ හිමිකරු සතුය.",
  "signalConfirmation.consentText": "මෙම සංඥාව සැබෑ තත්ත්වයක් පෙන්වන බවත්\nඑය spam හෝ අසත්‍ය වාර්තාවක් නොවන බවත්\nමම තහවුරු කරමි.",
  "signalConfirmation.warning": "යැවීමෙන් පසු සංඥාව\nවෙනස් කළ නොහැක",
  "signalConfirmation.sending": "යවමින්…",
  "signalConfirmation.send": "යවන්න",
  "partner.loadingAria": "පූරණය වෙමින්",
  "partner.title": "හවුල්කරු වැඩසටහන",
  "partner.offerLine1": "ඔබ BeepApp වෙත ආරාධනා කරන පරිශීලකයන්ගේ සියලු ගෙවීම්වලින්",
  "partner.offerLine2": "කාල සීමාවක් නොමැතිව 30% උපයන්න",
  "partner.offerLine3": "Telegram Affiliate හරහා",
  "partner.connectUnavailable": "Telegram Affiliate වැඩසටහන සකස් කළ පසු සම්බන්ධ වීම ලබාගත හැක.",
  "partner.connectTelegram": "Telegram තුළ සම්බන්ධ කරන්න",
  "partner.qrAria": "හවුල්කරු සබැඳියේ QR කේතය",
  "partner.download": "බාගන්න",
  "partner.promoHeading": "පුද්ගලික promo code එකක් සාදන්න",
  "partner.promoHelperLine1": "Promo code එක අමතර දායකත්ව වසරක් සක්‍රීය කරයි",
  "partner.promoHelperLine2": "සහ පරිශීලකයන් ආකර්ෂණය කිරීමට උපකාරී වේ",
  "partner.promoAria": "Promo code",
  "partner.affiliateHeading": "ඔබේ හවුල්කරු සබැඳිය",
  "partner.affiliateHelper": "පුද්ගලික QR කේතයක් සාදීමට සබැඳිය සුරකින්න",
  "partner.affiliateAria": "හවුල්කරු සබැඳිය",
  "partner.qrNoteLine1": "QR කේතය ඔබේ වාහනයේ,",
  "partner.qrNoteLine2": "සමාජ මාධ්‍යවල සහ ප්‍රචාරණ ද්‍රව්‍යවල තැබිය හැක",
  "partner.save": "සුරකින්න",
  "partner.reset": "නැවත සකසන්න",
  "partner.resetConfirm": "සුරකින ලද හවුල්කරු සබැඳිය නැවත සකසන්නද? Promo code එක ඔබටම පවතී.",
  "partner.promoFormatError": "Promo code එක අක්ෂර 4 සිට 15 දක්වා විය යුතුය.",
  "partner.affiliateHostError": "t.me හෝ telegram.me සබැඳි පමණක් අවසර ඇත.",
  "partner.affiliatePathError": "සබැඳියේ Telegram මාර්ගයක් නොමැත.",
  "partner.affiliateFormatError": "හවුල්කරු සබැඳිය වලංගු නොවේ.",
  "partner.loadError": "පූරණ දෝෂය",
  "partner.checkInputError": "ඇතුළත් කළ තොරතුරු පරීක්ෂා කරන්න",
  "garageActivation.promoInvalid": "Promo code එක වලංගු නොවේ",
  "garageActivation.plateOccupied": "මෙම වාහන අංකය දැනටමත් සම්බන්ධ කර ඇත",
  "garageActivation.activateError": "Garage සක්‍රීය කළ නොහැකි විය",
  "garageEntry.loadJournalError": "ලොග් පොත පූරණය කළ නොහැකි විය",
  "garageEntry.loadStatusesError": "තත්ත්වයන් පූරණය කළ නොහැකි විය",
  "garageEntry.activationSuccess": "Garage සාර්ථකව සක්‍රීය විය",
  "garageEntry.plateAttached": "අංකය සම්බන්ධ විය",
  "garageEntry.attachError": "අංකය සම්බන්ධ කළ නොහැකි විය",
  "garageEntry.activationNote": "ඔබේ Garage සක්‍රීය කරන්න",
  "garageSheet.activationTitle": "Garage සක්‍රීය කිරීම",
  "garageSheet.plateHelper": "වාහනයේ අංකය ඇතුළත් කරන්න",
  "garageSheet.promoHelper": "ඔබට promo code එකක් තිබේද?",
  "garageSheet.cleanBonusLine1": "සක්‍රීය කිරීමෙන් පසු පැය 1ක් තුළ",
  "garageSheet.cleanBonusLine2": "“Clean Start” නොමිලේ ලබාගත හැක",
  "garageSheet.activationFor": "සක්‍රීය කාලය",
  "garageSheet.cost": "මිල",
  "garageSheet.ownerConsentLine1": "සඳහන් කළ අංකය සහිත",
  "garageSheet.ownerConsentLine2": "වාහනයේ හිමිකරු මම බව",
  "garageSheet.ownerConsentLine3": "තහවුරු කරමි.",
  "garageSheet.processing": "සකසමින්...",
  "garageSheet.attach": "සම්බන්ධ කරන්න",
  "garageSheet.pay": "ගෙවන්න",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Garage අක්‍රීය කිරීම",
  "garageLifecycle.cleanWarningLine1": "අංකයේ ඉතිහාසය මකා දමනු ඇත",
  "garageLifecycle.cleanWarningLine2": "එය නැවත ලබාගත නොහැක!",
  "garageLifecycle.deactivateWarningLine1": "අක්‍රීය කිරීමෙන් පසු සක්‍රීය",
  "garageLifecycle.deactivateWarningLine2": "Garage විශේෂාංග වෙත ප්‍රවේශය අවසන් වේ",
  "garageLifecycle.willBeDeleted": "මකා දමනු ඇත",
  "garageLifecycle.cleanRemovedLine1": "• ලොග් පොතේ සියලු සටහන්",
  "garageLifecycle.cleanRemovedLine2": "• ලැබුණු සංඥා ඉතිහාසය",
  "garageLifecycle.cleanRemovedLine3": "• අංක පත්‍රිකාවේ පොදු",
  "garageLifecycle.cleanRemovedLine4": "  සංඥා ගණක",
  "garageLifecycle.willRemain": "පවතිනු ඇත",
  "garageLifecycle.cleanPreservedLine1": "• අංකය Garage සමඟ සම්බන්ධ වීම",
  "garageLifecycle.cleanPreservedLine2": "• ඉතිරි සක්‍රීය කාලය",
  "garageLifecycle.cleanPreservedLine3": "• තෝරාගත් අංක තත්ත්වය",
  "garageLifecycle.cleanPreservedLine4": "• අංක පත්‍රිකාවේ මුළු බැලීම්",
  "garageLifecycle.freeFirstHour": "පළමු පැය තුළ නොමිලේ",
  "garageLifecycle.willBecomeUnavailable": "ලබාගත නොහැකි වේ",
  "garageLifecycle.deactivateRemovedLine1": "• ලොග් පොත",
  "garageLifecycle.deactivateRemovedLine2": "• අංක තත්ත්වය තේරීම සහ භාවිතය",
  "garageLifecycle.deactivateRemovedLine3": "• ඔබ AutoClan වෙතින් ස්වයංක්‍රීයව ඉවත් වේ",
  "garageLifecycle.deactivateRemovedLine4": "• වාහන වෙළඳපොළ",
  "garageLifecycle.deactivateRemovedLine5": "• රක්ෂණය",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• මාර්ග සහාය",
  "garageLifecycle.deactivateRemovedLine8": "• අංකය Garage වෙතින් විසන්ධි වේ",
  "garageLifecycle.willRemainAvailable": "ලබාගත හැකිව පවතී",
  "garageLifecycle.deactivatePreservedLine1": "• Companion",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• අංක සෙවීම සහ",
  "garageLifecycle.deactivatePreservedLine4": "  පොදු වාහන පත්‍රිකාව බැලීම",
  "garageLifecycle.deactivatePreservedLine5": "• ඕනෑම වේලාවක Garage",
  "garageLifecycle.deactivatePreservedLine6": "  නැවත සක්‍රීය කිරීමේ හැකියාව",
  "garageLifecycle.cleanConsentLine1": "මෙම අංකයේ සම්පූර්ණ ඉතිහාසය",
  "garageLifecycle.cleanConsentLine2": "නැවත ලබාගත නොහැකි ලෙස මකා දැමීමට",
  "garageLifecycle.cleanConsentLine3": "මම එකඟ වෙමි.",
  "garageLifecycle.deactivateConsentLine1": "අක්‍රීය කිරීම සහ සියලු සක්‍රීය",
  "garageLifecycle.deactivateConsentLine2": "Garage විශේෂාංග වෙත ප්‍රවේශය",
  "garageLifecycle.deactivateConsentLine3": "අවසන් කිරීම තහවුරු කරමි.",
  "garageLifecycle.clean": "මකන්න",
  "garageLifecycle.deactivate": "අක්‍රීය කරන්න",
} satisfies Record<MessageKey, string>
